export default "__VITE_ASSET__CbyvHMkg__"